export const maxSubLineCount = 100
export const maxContactsCount = 15
export const minContactsCount = 1
